<template>
  <div class="expertise-areas">
    <!-- 头部导航 -->
    <Header />

    <!-- 主要内容 -->
    <main class="main-content">
           <!-- 顶部大图 -->
      <section class="banner-section">
        <img src="@/assets/images/zhuanye.png" :alt="$t('expertise.pageTitle')" class="banner-image">
      </section>
      <!-- 页面标题部分 -->
      <section class="page-header">
        <div class="container">
          <h1 class="page-title">{{ $t('expertise.pageTitle') }}</h1>
        </div>
      </section>

      <!-- 内容区域 -->
      <section class="content-section">
        <div class="container">
          <!-- 介绍文字 -->
          <div class="intro-section">
            <p class="intro-text">
              {{ $t('expertise.intro1') }}
            </p>
            <p class="intro-text">
              {{ $t('expertise.intro2') }}
            </p>
          </div>

          <!-- 专业领域列表 -->
          <div class="expertise-grid">
            <div class="expertise-column">
              <div class="expertise-item" v-for="item in leftColumnItems" :key="item">
                <span class="expertise-text">{{ $t(`expertise.areas.${item}`) }}</span>
              </div>
            </div>
            <div class="expertise-column">
              <div class="expertise-item" v-for="item in rightColumnItems" :key="item">
                <span class="expertise-text">{{ $t(`expertise.areas.${item}`) }}</span>
              </div>
            </div>
          </div>

          <!-- 服务承诺 -->
          <div class="service-commitment">
            <div class="commitment-card">
              <div class="commitment-icon">
                <i class="el-icon-medal"></i>
              </div>
              <div class="commitment-content">
                <h3 class="commitment-title">{{ $t('expertise.serviceTitle') }}</h3>
                <p class="commitment-text">
                  {{ $t('expertise.serviceText') }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- 药品专利链接制度 -->
      <section class="pharma-patent-section">
        <div class="container">
          <div class="section-header">
            <h2 class="pharma-title">{{ $t('practice.pharma.title') }}</h2>
          </div>

          <div class="pharma-description">
            <p class="description-text" v-html="$t('practice.pharma.description')"></p>
          </div>

          <div class="certificates-grid">
            <div class="certificate-item">
              <div class="certificate-image">
                <img :src="certificate1" alt="KES Pharma GmbH感谢函" class="cert-img">
              </div>
              <div class="certificate-caption">
                <p class="cert-text">{{ $t('practice.textn1') }}</p>
              </div>
            </div>

            <div class="certificate-item">
              <div class="certificate-image">
                <img :src="certificate2" alt="北京天衡药物研究院感谢函" class="cert-img">
              </div>
              <div class="certificate-caption">
                <p class="cert-text">{{ $t('practice.textn2') }}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <!-- 页脚 -->
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  name: 'ExpertiseAreas',
  components: {
    Header,
    Footer
  },
  data() {
    return {
        certificate1: require('@/assets/images/teamimg/anli03.png'),
      certificate2: require('@/assets/images/teamimg/anli04.png'),
      leftColumnItems: [
        'communication',
        'fiberOptics',
        'electronicComponents',
        'highCurrentSwitches',
        'weighing',
        'xray',
        'conveying',
        'metrology',
        'inspection',
        'automotive',
        'construction',
        'machineTools',
        'storage',
        'coating',
        'structural'
      ],
      rightColumnItems: [
        'alloys',
        'welding',
        'organicChemistry',
        'polymer',
        'pharmaceutical',
        'biotech',
        'chromatography',
        'catalysts',
        'oled',
        'semiconductor',
        'medical',
        'gaming',
        'control',
        'automation',
        'foodProduction'
      ]
    }
  }
}
</script>

<style scoped>
/* 顶部大图部分 */
.banner-section {
  width: 100%;
  height: 33.6rem;
  overflow: hidden;
  position: relative;
}

.banner-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.expertise-areas {
  font-family: 'Helvetica Neue', Arial, sans-serif;
  color: #333;
}

.main-content {
  min-height: 80vh;
}

/* 页面标题部分 */
.page-header {
  background-color: #FFF5F0;
  padding: 3rem 0 0 0;
  text-align: center;
  border-bottom: 1px solid #e9ecef;
}

.container {
  width: 1200px;
  margin: 0 auto;
  padding: 0 2rem;
}

.page-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #FF631E;
}

.page-subtitle {
  font-size: 1.2rem;
  font-weight: 300;
  margin: 0;
  color: #666;
}

/* 内容区域 */
.content-section {
  padding: 4rem 0;
  background-color: #FFF5F0;
}

.intro-section {
  background: white;
  border-radius: 12px;
  padding: 2rem 2rem;
  margin-bottom: 3rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.intro-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #333;
  margin-bottom: 1.5rem;
  text-align: justify;
}

.intro-text:last-child {
  margin-bottom: 0;
}

.expertise-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem;
  background: white;
  border-radius: 12px;
  padding: 3rem;
  margin-bottom: 3rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.expertise-column {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.expertise-item {
  display: flex;
  align-items: center;
  border-radius: 8px;
  transition: all 0.3s ease;
  border-left: 4px solid transparent;
}

.expertise-item:hover {
  transform: translateX(5px);
  box-shadow: 0 2px 10px rgba(255, 99, 30, 0.1);
}

.expertise-icon {
  width: 40px;
  height: 40px;
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  flex-shrink: 0;
}

.expertise-icon i {
  color: white;
  font-size: 1.2rem;
}

.expertise-text {
  font-size: 1rem;
  color: #333;
  font-weight: 500;
}

.service-commitment {
  background: white;
  border-radius: 12px;
  padding: 3rem;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
}

.commitment-card {
  display: flex;
  align-items: flex-start;
  gap: 2rem;
}

.commitment-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.commitment-icon i {
  color: white;
  font-size: 2rem;
}

.commitment-content {
  flex: 1;
}

.commitment-title {
  font-size: 1.5rem;
  font-weight: 600;
  color: #333;
  margin: 0 0 1rem 0;
}

.commitment-text {
  font-size: 1.1rem;
  line-height: 1.8;
  color: #666;
  margin: 0;
  text-align: justify;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .container {
    width: 90%;
  }
    .banner-section {
    height: 600px;
  }
}

@media (max-width: 992px) {
  .page-title {
    font-size: 2rem;
  }
  
  .expertise-grid {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
  
  .commitment-card {
    flex-direction: column;
    text-align: center;
    gap: 1.5rem;
  }
    
  .banner-section {
    height: 500px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 1rem;
  }
    
  .banner-section {
    height: 400px;
  }
  .page-header {
    padding: 2rem 0;
  }
  
  .page-title {
    font-size: 1.8rem;
  }
  
  .intro-section,
  .expertise-grid,
  .service-commitment {
    padding: 2rem;
  }
  
  .content-section {
    padding: 2rem 0;
  }
}

@media (max-width: 576px) {
  .page-title {
    font-size: 1.6rem;
  }
    .banner-section {
    height: 300px;
  }
  .expertise-item {
    padding: 0.8rem;
  }
  
  .expertise-icon {
    width: 35px;
    height: 35px;
    margin-right: 0.8rem;
  }
  
  .expertise-icon i {
    font-size: 1rem;
  }
  
  .expertise-text {
    font-size: 0.9rem;
  }
  
  .intro-section,
  .expertise-grid,
  .service-commitment {
    padding: 1.5rem;
  }
}

/* 药品专利链接制度模块样式 */
.pharma-patent-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  position: relative;
}

.pharma-patent-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="pharma-dots" width="40" height="40" patternUnits="userSpaceOnUse"><circle cx="20" cy="20" r="1.5" fill="%23FF631E" opacity="0.1"/></pattern></defs><rect width="100" height="100" fill="url(%23pharma-dots)"/></svg>');
  pointer-events: none;
}

.pharma-patent-section .section-header {
  text-align: center;
  margin-bottom: 3rem;
  position: relative;
  z-index: 1;
}

.pharma-title {
  font-size: 2.8rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.pharma-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 100px;
  height: 4px;
  border-radius: 2px;
}

.pharma-description {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 1;
}

.description-text {
  font-size: 1.2rem;
  line-height: 1.8;
  color: #4a5568;
  margin: 0 auto;
  background: white;
  padding: 2.5rem;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.08);
  border: 1px solid #e2e8f0;
  position: relative;
}

.description-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.1) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  border-radius: 16px;
  z-index: 1;
}

.description-text:hover::before {
  opacity: 1;
}

.certificates-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  position: relative;
  z-index: 1;
}

.certificate-item {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
}

.certificate-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 99, 30, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.certificate-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.certificate-item:hover::before {
  opacity: 1;
}

.certificate-image {
  position: relative;
  overflow: hidden;
  z-index: 2;
}

.cert-img {
  width: 100%;
  height: 36rem;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.certificate-item:hover .cert-img {
  transform: scale(1.02);
}

.certificate-caption {
  padding: 2rem;
  text-align: center;
  position: relative;
  z-index: 2;
}

.cert-text {
  font-size: 1.1rem;
  font-weight: 600;
  color: #FF631E;
  margin: 0;
  line-height: 1.5;
  position: relative;
  padding-top: 1rem;
}

.showcase-cta {
  text-align: center;
  margin-top: 2rem;
  /* margin-bottom: 2rem; */
}

.cta-button {
  background: linear-gradient(135deg, #FF631E, #ff7a3d);
  border: none;
  padding: 1rem 2.5rem;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 50px;
  box-shadow: 0 6px 20px rgba(255, 99, 30, 0.3);
  transition: all 0.3s ease;
}

.cta-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(255, 99, 30, 0.4);
}

.cert-text::before {
  content: '';
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  border-radius: 2px;
}

/* 响应式设计 - 药品专利链接制度模块 */
@media (max-width: 1024px) {
  .pharma-title {
    font-size: 2.4rem;
  }

  .description-text {
    font-size: 1.1rem;
    padding: 2rem;
  }

  .certificates-grid {
    gap: 2rem;
  }
}

@media (max-width: 768px) {
  .pharma-patent-section {
    padding: 4rem 0;
  }

  .pharma-title {
    font-size: 2rem;
  }

  .description-text {
    font-size: 1rem;
    padding: 1.5rem;
  }

  .certificates-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .certificate-caption {
    padding: 1.5rem;
  }

  .cert-text {
    font-size: 1rem;
  }
}

@media (max-width: 576px) {
  .pharma-patent-section {
    padding: 3rem 0;
  }

  .pharma-title {
    font-size: 1.6rem;
  }

  .description-text {
    font-size: 0.95rem;
    padding: 1.2rem;
    line-height: 1.7;
  }

  .certificate-caption {
    padding: 1.2rem;
  }

  .cert-text {
    font-size: 0.9rem;
  }
}

@media (max-width: 360px) {
  .pharma-title {
    font-size: 1.4rem;
  }

  .description-text {
    font-size: 0.9rem;
    padding: 1rem;
  }

  .certificate-caption {
    padding: 1rem;
  }

  .cert-text {
    font-size: 0.85rem;
  }
}

/* 授权周期快模块样式 */
.fast-authorization-section {
  padding: 5rem 0;
  background: linear-gradient(135deg, #f0f8ff 0%, #ffffff 100%);
  position: relative;
}

.fast-authorization-section::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="auth-dots" width="35" height="35" patternUnits="userSpaceOnUse"><circle cx="17.5" cy="17.5" r="1.8" fill="%23FF631E" opacity="0.08"/></pattern></defs><rect width="100" height="100" fill="url(%23auth-dots)"/></svg>');
  pointer-events: none;
}

.fast-authorization-section .section-header {
  text-align: center;
  margin-bottom: 4rem;
  position: relative;
  z-index: 1;
}

.authorization-title {
  font-size: 2.2rem;
  font-weight: 700;
  color: #1a202c;
  margin-bottom: 1rem;
  line-height: 1.3;
  position: relative;
  display: inline-block;
}

.authorization-title::after {
  content: '';
  position: absolute;
  bottom: -0.8rem;
  left: 50%;
  transform: translateX(-50%);
  width: 120px;
  height: 4px;
  border-radius: 2px;
}

.authorization-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 3rem;
  position: relative;
  z-index: 1;
}

.authorization-item {
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 1px solid #e2e8f0;
  position: relative;
  display: flex;
  flex-direction: column;
}

.authorization-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 99, 30, 0.05) 50%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}

.authorization-item:hover {
  transform: translateY(-10px);
  box-shadow: 0 25px 50px rgba(0, 0, 0, 0.15);
}

.authorization-item:hover::before {
  opacity: 1;
}

.auth-image {
  position: relative;
  overflow: hidden;
  z-index: 2;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.auth-img {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: contain;
  display: block;
  transition: transform 0.3s ease;
}

.authorization-item:hover .auth-img {
  transform: scale(1.05);
}

.auth-content {
  padding: 2rem;
  text-align: center;
  position: relative;
  z-index: 2;
  background: linear-gradient(135deg, #fff8f5 0%, #ffffff 100%);
  border-top: 1px solid rgba(255, 99, 30, 0.1);
}

.auth-text {
  font-size: 1.3rem;
  font-weight: 700;
  color: #FF631E;
  margin: 0;
  line-height: 1.4;
  position: relative;
}

.auth-text::before {
  content: '';
  position: absolute;
  top: -1rem;
  left: 50%;
  transform: translateX(-50%);
  width: 60px;
  height: 3px;
  background: linear-gradient(90deg, #FF631E, #ff8c42);
  border-radius: 2px;
}

/* 响应式设计 - 授权周期快模块 */
@media (max-width: 1024px) {
  .authorization-title {
    font-size: 2.4rem;
  }

  .authorization-grid {
    gap: 2rem;
  }

  .auth-image {
    padding: 1.5rem;
  }

  .auth-content {
    padding: 1.5rem;
  }

  .auth-text {
    font-size: 1.2rem;
  }
}

@media (max-width: 768px) {
  .fast-authorization-section {
    padding: 4rem 0;
  }

  .authorization-title {
    font-size: 2rem;
  }

  .authorization-grid {
    grid-template-columns: 1fr;
    gap: 2rem;
  }

  .auth-image {
    padding: 1.2rem;
  }

  .auth-img {
    max-height: 250px;
  }

  .auth-content {
    padding: 1.2rem;
  }

  .auth-text {
    font-size: 1.1rem;
  }
}

@media (max-width: 576px) {
  .fast-authorization-section {
    padding: 3rem 0;
  }

  .authorization-title {
    font-size: 1.6rem;
  }

  .auth-image {
    padding: 1rem;
  }

  .auth-img {
    max-height: 200px;
  }

  .auth-content {
    padding: 1rem;
  }

  .auth-text {
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  .authorization-title {
    font-size: 1.4rem;
  }

  .auth-image {
    padding: 0.8rem;
  }

  .auth-img {
    max-height: 180px;
  }

  .auth-content {
    padding: 0.8rem;
  }

  .auth-text {
    font-size: 0.9rem;
  }
}

.highlight-blue {
  color: #FF631E;
  font-weight: 600;
}

/* 弹窗移动端优化样式 */
@media (max-width: 640px) {
  /* 平板端优化 */
  .contact-dialog .el-dialog {
    width: 90% !important;
    margin: 0 auto;
    top: 2vh !important;
  }

  .dialog-content {
    padding: 2rem 1.5rem;
  }

  .dialog-title {
    font-size: 1.8rem;
    line-height: 1.3;
  }

  .dialog-body {
    flex-direction: column;
    gap: 2rem;
  }

  .dialog-body .image-gallery {
    flex: none;
    width: 100%;
  }

  .dialog-body .text-content {
    flex: none;
    width: 100%;
  }

  .gallery-item {
    flex-direction: row;
    text-align: left;
    padding: 1rem;
    gap: 1rem;
  }

  .gallery-item img {
    width: 120px;
    max-width: 120px;
    flex-shrink: 0;
  }

  .gallery-image {
    height: 80px;
  }

  .gallery-item .item-caption {
    margin-top: 0;
    margin-left: 0;
    font-size: 0.95rem;
    flex: 1;
    display: flex;
    align-items: center;
  }
}

@media (max-width: 480px) {
  /* 移动端优化 */
  .contact-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
    top: 1vh !important;
    max-height: 95vh;
  }

  .contact-dialog .el-dialog__body {
    max-height: 85vh;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }

  .dialog-content {
    padding: 1.5rem 1rem;
  }

  .dialog-title {
    font-size: 1.5rem;
    line-height: 1.4;
    margin-bottom: 1rem;
  }

  .dialog-body {
    gap: 1.5rem;
  }

  .dialog-body .text-content {
    font-size: 0.9rem;
    line-height: 1.7;
  }

  .gallery-item {
    padding: 0.8rem;
    margin-bottom: 0.8rem;
    border-radius: 8px;
    flex-direction: column;
    text-align: center;
  }

  .gallery-item img {
    width: 100%;
    max-width: 250px;
    margin: 0 auto;
  }

  .gallery-image {
    height: 120px;
  }

  .gallery-item .item-caption {
    margin-top: 0.8rem;
    margin-left: 0;
    font-size: 0.9rem;
    font-weight: 600;
    color: #FF631E;
  }

  .dialog-footer {
    margin-top: 1rem;
    padding-top: 1rem;
    border-top: 1px solid #e2e8f0;
  }

  .dialog-footer .el-button {
    width: 100%;
    padding: 0.8rem 1.5rem;
    font-size: 1rem;
  }
}

@media (max-width: 360px) {
  /* 小屏幕移动端优化 */
  .contact-dialog .el-dialog {
    width: 98% !important;
  }

  .dialog-content {
    padding: 1rem 0.8rem;
  }

  .dialog-title {
    font-size: 1.3rem;
    line-height: 1.3;
  }

  .dialog-body .text-content {
    font-size: 0.85rem;
    line-height: 1.6;
  }

  .gallery-item {
    padding: 0.6rem;
  }

  .gallery-image {
    height: 100px;
  }

  .gallery-item .item-caption {
    font-size: 0.85rem;
    margin-top: 0.6rem;
  }
}

/* 弹窗动画效果 */
.contact-dialog .el-dialog {
  animation: dialogSlideIn 0.3s ease-out;
}

@keyframes dialogSlideIn {
  from {
    opacity: 0;
    transform: translateY(-20px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

/* 图片加载动画 */
.gallery-item img {
  transition: all 0.3s ease;
}

.gallery-item:hover img {
  transform: scale(1.02);
}

/* 触摸友好的按钮样式 */
@media (max-width: 768px) {
  .gallery-item {
    cursor: pointer;
    -webkit-tap-highlight-color: rgba(255, 99, 30, 0.1);
    tap-highlight-color: rgba(255, 99, 30, 0.1);
  }

  .gallery-item:active {
    transform: scale(0.98);
    background-color: rgba(255, 99, 30, 0.05);
  }

  .dialog-footer .el-button {
    -webkit-tap-highlight-color: transparent;
    tap-highlight-color: transparent;
  }

  .dialog-footer .el-button:active {
    transform: scale(0.98);
  }
}

/* 滚动条样式优化 */
.contact-dialog .el-dialog__body::-webkit-scrollbar {
  width: 4px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 2px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #FF631E;
  border-radius: 2px;
}

.contact-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #e55a1a;
}

/* 文本选择优化 */
.dialog-content {
  -webkit-user-select: text;
  -moz-user-select: text;
  -ms-user-select: text;
  user-select: text;
}

/* 高亮文本移动端优化 */
.highlight-blue {
  padding: 2px 4px;
  border-radius: 3px;
}

@media (max-width: 480px) {
  .highlight-blue {
    padding: 1px 3px;
    font-size: 0.9em;
  }
}
</style>